import { Dispatch, SetStateAction, useEffect, useState } from "react";
import styled from "styled-components";
import { AddCircleOutline, RemoveCircleOutline } from "styled-icons/material";

import GnarlyPng from "../../assets/gnarly_1.png";
import { SalesInfo, SaleType } from "../../constants/sale";
import {
  GasEstimateLevels,
  GasEstimatesMap,
  useGasEstimates
} from "../../hooks/useGasEstimates";
import {
  Interface,
  SelectorButton,
  SelectorInterface,
  Text
} from "../../theme/components";

const IncreaseMintAmount = styled(AddCircleOutline)`
	:hover {
		cursor: pointer;
		user-select: none;
	}
`
const DecreaseMintAmount = styled(RemoveCircleOutline)`
	:hover {
		cursor: pointer;
		user-select: none;
	}
`
export interface Props {
	gasEstimatesMap?: GasEstimatesMap
	selectedGasEstimateLevel: string
	setGasEstimateLevel: Dispatch<SetStateAction<GasEstimateLevels>>
	saleType: SaleType
	mintAmount: number
	toggleMintAmount: (amount: number) => void
}

const GasEstimateDashboard = ({
	gasEstimatesMap,
	selectedGasEstimateLevel,
	setGasEstimateLevel,
	saleType,
	mintAmount,
	toggleMintAmount,
}: Props) => {
	useEffect(() => {
		console.log(gasEstimatesMap)
	}, [gasEstimatesMap])

	const amountSelector = () => {
		if (saleType !== SaleType.RedeemMintPasses) {
			return (
				<Interface responsive justifyContent="center">
					<DecreaseMintAmount
						size={28}
						onClick={() => {
							if (mintAmount > 1) {
								toggleMintAmount(mintAmount - 1)
							}
						}}
					/>

					<Text primary3 fontSize={20}>
						{mintAmount}
					</Text>

					<IncreaseMintAmount
						size={28}
						onClick={() => {
							if (mintAmount < SalesInfo[saleType].maxTxnAmount) {
								toggleMintAmount(mintAmount + 1)
							}
						}}
					/>
				</Interface>
			)
		}
	}

	return (
		<>
			{amountSelector()}

			{gasEstimatesMap === undefined && (
				<>
					<img alt={''} src={GnarlyPng} width={'350px'}></img>
				</>
			)}

			{gasEstimatesMap !== undefined && (
				<>
					<Text>Gas Settings:</Text>
					<SelectorInterface>
						{Object.entries(gasEstimatesMap).map((gasEstimate, i) => {
							return (
								<SelectorButton
									key={`${gasEstimate[0]} Gas Estimate`}
									selected={
										gasEstimate[0] ===
										(selectedGasEstimateLevel as GasEstimateLevels)
									}
									onClick={() => {
										setGasEstimateLevel(gasEstimate[0] as GasEstimateLevels)
									}}>
									<Interface col>
										<Text raw color1>
											{gasEstimate?.[1].prettyCostInGwei}
										</Text>
										<Text gasEstimate={gasEstimate[0]}>{gasEstimate[0]}</Text>
										<Text raw fontSize={11}>
											{gasEstimate?.[1].prettyCostInUsd}
										</Text>
									</Interface>
								</SelectorButton>
							)
						})}
					</SelectorInterface>
				</>
			)}
		</>
	)
}
export default GasEstimateDashboard
